import { IamRouterTable } from "@/types/api/login";
export type RouteTemplte = Omit<IamRouterTable, "funcId" | "portalId">;
// import { t } from '@/locales/i18n'
/**
 * 子应用名配置，对应用户中心的portalCode
 */

type F2EHB_NAME = "F2E-harbour-web";
type HARBOUR_CONTAINER_PC = "harbour-container-pc";
type CONTRACT_MANAGEMENT_PC = "contract-management-pc";
type CUSTOMER_MESSAGE_PC = "customer-message-pc";
type BASE_BIZ_DATA_ADMIN_PC = "base-biz-data-admin-pc";
type HARBOUR_PORTAL_PC= "harbour-portal-pc";
type FTBOSS_PC = "ftboss-pc";
type ECOMMERCE_PC = "ecommerce-client";
type ECOMMERCE_CHILD_PC = "ecommerce-child-client"
type IAM_ADMIN_PC = "iam-admin-pc";
type ACCOUNTING_CENTER_PC ="accounting-center-web-pc";
type DUCKBILL_PPC_WEB = 'duckbill-ppc-web';
type TTP_WEB_PC = 'ttp-web-pc';
type TTP_ADMIN_PC = 'ttp-admin-pc';
type CALL_CENTER_ADMIN_PC = 'call-center-admin-pc';

export const HARBOUR_PORTAL_PC: HARBOUR_PORTAL_PC = "harbour-portal-pc";
export const F2EHB_NAME: F2EHB_NAME = "F2E-harbour-web";
export const HARBOUR_CONTAINER_PC: HARBOUR_CONTAINER_PC = "harbour-container-pc";
export const CONTRACT_MANAGEMENT_PC: CONTRACT_MANAGEMENT_PC =
  "contract-management-pc";
export const CUSTOMER_MESSAGE_PC: CUSTOMER_MESSAGE_PC = "customer-message-pc";
export const BASE_BIZ_DATA_ADMIN_PC: BASE_BIZ_DATA_ADMIN_PC =
  "base-biz-data-admin-pc";
export const FTBOSS_PC: FTBOSS_PC = "ftboss-pc";
export const ECOMMERCE_PC:ECOMMERCE_PC = "ecommerce-client"
export const ECOMMERCE_CHILD_PC:ECOMMERCE_CHILD_PC = "ecommerce-child-client"
export const ACCOUNTING_CENTER_PC:ACCOUNTING_CENTER_PC = "accounting-center-web-pc"
export const IAM_ADMIN_PC:IAM_ADMIN_PC = "iam-admin-pc"
export const DUCKBILL_PPC_WEB:DUCKBILL_PPC_WEB = "duckbill-ppc-web"
export const TTP_WEB_PC:TTP_WEB_PC = "ttp-web-pc"
export const TTP_ADMIN_PC:TTP_ADMIN_PC = "ttp-admin-pc"
export const CALL_CENTER_ADMIN_PC:CALL_CENTER_ADMIN_PC = "call-center-admin-pc"

/**
 *  子应用入口组件路由
 */
export const F2EHB_APP_ROUTE: RouteTemplte = {
  appName: F2EHB_NAME,
  funcName: "鸭嘴兽中台",
  path: "/child-container/yzs-f2e",
  status: true,
  funcType: "TAB",
  children: [],
  hasChildren: false,
  funcSort: 0,
  isShow: 0,
  component: "/ChildContainer/yzs-f2e",
  icon: "#",
  query: "control-center", // 添加默认页面
};

interface TabItem {
  app: AppCollection;
  childAppPath?: string;
  title: string;
  fullPath: string;
  path: string;
  name?: string;
  query?: any;
  params?: any;
}
// console.log(t,'dddddddddddddd')
export const defaultTab: TabItem = {
  app: "F2E-harbour-web",
  childAppPath: "/control-center",
  fullPath: "/child-container/yzs-f2e?F2E-harbour-web=#/control-center",
  name: "workbenches" ,
  path: "/child-container/yzs-f2e?F2E-harbour-web=%23%2Fcontrol-center",
  query: undefined,
  title: "workbenches",
};
export const CHILD_APP_ROUTE_LIST = [F2EHB_APP_ROUTE];

export type AppCollection =
  | F2EHB_NAME
  | HARBOUR_CONTAINER_PC
  | CONTRACT_MANAGEMENT_PC
  | CUSTOMER_MESSAGE_PC
  | BASE_BIZ_DATA_ADMIN_PC
  | HARBOUR_PORTAL_PC
  | FTBOSS_PC
  | ECOMMERCE_PC
  | ECOMMERCE_CHILD_PC
  | IAM_ADMIN_PC
  | ACCOUNTING_CENTER_PC
  | DUCKBILL_PPC_WEB
  | TTP_WEB_PC
  | TTP_ADMIN_PC
  | CALL_CENTER_ADMIN_PC